//#region Asset Imports

import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

//#region IMR Imports



//#endregion

import { TypeHelper, LocalizationHelper, ToastHelper, ConvertHelper, LogHelper } from "../../../../helpers"

import { OpPackage } from "../../../../models/core/op-package"

import { ISearchBySerialNbr, SearchBySerialNbrOpitons } from './order-search-by-serial-nbr.interfaces'
import { UserSessionService } from '../../../../services/user-session';
import { IMRPopupOptions, IIMRPopup } from '@imr/controls.angularjs/components/overlay/popup'
import { IMRComponentInitializedArgs } from '@imr/controls.angularjs/components/base'

export class OrderSearchBySerialNbrController implements ng.IComponentController, ISearchBySerialNbr {

    // #region Consts

    private static get LOG_PREFIX(): string { return '[SIMAX.Module.OrderSearchBySerialNbr]' }

    // #endregion

    // #region Members

    public popupOptions: IMRPopupOptions

    private imrPopup: IIMRPopup
    private options: SearchBySerialNbrOpitons
    private toolbarOptions: DevExpress.ui.dxToolbarOptions
    private numberBox: DevExpress.ui.dxNumberBox

    // #endregion

    // #region Ctor

    constructor(
        private userSession: UserSessionService
    ) {
    }

    // #endregion

    // #region IComponentController

    public $onChanges(changes: { [index: string]: ng.IChangesObject<any> }): void {
        if (TypeHelper.isOptionsDefined(changes)) {
            this.initialize()
        }
    }

    // #endregion

    // #region ISearchBySerialNbr Implementation

    public show() {
        this.imrPopup.show()
    }

    // #endregion

    // #region Setup

    private initialize(): void {
        this.setPopupOptions()
        this.onInitialized()
    }

    // #endregion

    // #region Popup
    private setPopupOptions(): any {
        this.popupOptions = {
            bottomToolbarOptions: {
                innerOptions: {
                    items: [{
                        widget: 'dxNumberBox',
                        options: {
                            onInitialized: (e: any) => {
                                this.numberBox = e.component
                            },
                            onFocusIn: (e: any) => {
                                this.setNumberBoxValue()
                            }

                        },
                    }, {
                        location: 'after',
                        widget: 'dxButton',
                        options: {
                            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Cancel),
                            onClick: () => {
                                this.imrPopup.hide()
                            }
                        }
                    }, {
                        location: 'after',
                        widget: 'dxButton',
                        options: {
                            text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Submit),
                            onClick: (e: any) => {
                                this.imrPopup.hide()
                                this.findPackage()
                                this.setNumberBoxValue()
                            }
                        }
                    }]
                }
            },

            innerOptions: {
                title: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.FindPackageBySerialNbr),
                width: '400',
                height: 'auto',

                onHidden: () => {
                    this.reset()
                }
            },

            onInitialized: (e: IMRComponentInitializedArgs<IIMRPopup>) => {
                this.imrPopup = e.component
            }
        }

        return TypeHelper.onInitializedAll(this.popupOptions)
    }

    private reset(): void {
        this.setNumberBoxValue()
    }

    // #endregion

    // #region Numberbox

    private setNumberBoxValue(value: number = null): void {
        this.numberBox.option('value', value)
    }

    // #endregion

    // #region Private Methods

    private findPackage(): void {
        const currentPackageSerialNbr: string = this.numberBox.option('value').toString()
        if (currentPackageSerialNbr != null) {

            this.userSession.getDataProvider().Package.findPackageBySerialNbr(currentPackageSerialNbr)
                .then((packs: OpPackage[]) => {
                    if (_.size(packs) > 0) {
                        this.onFoundPackage(packs)
                    } else {
                        ToastHelper.showWarning(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.PackageNotFound) + ': ' + currentPackageSerialNbr)
                    }
                })
                .fail((error: any) => {
                    const errorMsg: string = ConvertHelper.getRequestErrorMessage(error) || LocalizationHelper.getLocalizedText(LocalizationHelper.Text.ExceptionOccuredPleaseContactAnAdministrator)
                    LogHelper.error(OrderSearchBySerialNbrController.LOG_PREFIX, errorMsg)
                    ToastHelper.showError(errorMsg)
                })
        }
    }

    // #endregion

    // #region Events

    private onInitialized(): void {
        if (this.options != null && _.isFunction(this.options.onInitialized)) {
            this.options.onInitialized(this)
        }
    }

    private onFoundPackage(packs: OpPackage[]): void {
        if (this.options != null && _.isFunction(this.options.onFoundPackage)) {
            this.options.onFoundPackage(packs.map((pack: OpPackage) => pack.idPackage))
        }
    }

    // #endregion
}